import React from 'react';
import UserDashboard from '../../UserDashboard';



export default function Beneficiaries () {
    return (
        <UserDashboard>
        </UserDashboard>
    )
}